<template>
  <div>
    <div class="majorTitle textLeft">
      Alerts
    </div>
    <div class="minorTitle">
      Phone Notifications
    </div>
    <div class="colorGrey marginNormalBottom">
      <span class="marginSmallBottom">Use the toggle below to Opt-In or Opt-Out of SMS mobile notifications.</span><br>
      If you elect to Opt-In, provide a U.S. mobile number and receive “selling soon” and “outbid” notifications. You may Opt-Out at any time.<br>
    </div>
    <div class="notificationContainer paddingNormalBottom flexBox">
      <div class="flexBox switchContainer">
        <div class="onoffswitch marginSmallRight">
          <input
            id="myonoffswitch"
            v-model="enableSms"
            type="checkbox"
            name="onoffswitch"
            class="onoffswitch-checkbox"
          >
          <label
            class="onoffswitch-label"
            for="myonoffswitch"
          />
        </div>
      </div>
      <div
        v-if="!enableSms"
        class="marginSmallLeft paddingNormalBottom"
      >
        You are Opted-Out
      </div>
      <div
        class="shrinkContainer backgroundColorDimmer borderGrey"
        :class="{ shrink: !enableSms }"
      >
        <VuePhoneNumberInput
          ref="phoneNumber"
          v-model="phoneNumber"
          :no-validator-state="true"
          color="#007aff"
          valid-color="#34c263"
          error-color="#f44242"
          :no-country-selector="true"
          :default-country-code="'US'"
          :border-radius="0"
          @update="smsNumberUpdate"
          @phone-number-blur="smsNumberBlur"
        />
      </div>
      <div
        v-if="enableSms && isValidSmsNumber && phoneNumber.length > 0"
        class="marginSmallLeft"
      >
        You are Opted-In
      </div>
    </div>
    <div>
      *By Opting-In, you consent to receiving SMS communications from Leland Little Auctions, Ltd.
    </div>
    <div class="marginLargeTop minorTitle">
      Email Notifications
    </div>
    <div class="colorGrey marginNormalBottom">
      Enable e-mail notifications and receive information regarding recently posted auctions.
    </div>
    <div class="notificationContainer paddingNormalBottom marginLargeBottom flexBox">
      <div class="flexBox switchContainer">
        <div class="onoffswitch marginSmallRight">
          <input
            id="myonoffswitch2"
            v-model="enableEmail"
            type="checkbox"
            name="onoffswitch"
            class="onoffswitch-checkbox"
          >
          <label
            class="onoffswitch-label"
            for="myonoffswitch2"
          />
        </div>
      </div>
      <div
        class="shrinkContainer"
        :class="{ shrink: !enableEmail}"
      >
        <span
          class="fontLarge"
          v-text="customerEmailAddress"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

export default {
  name: 'NotificationsCard',
  components: {
    VuePhoneNumberInput
  },
  data () {
    return {
      'isValidSmsNumber': false
    }
  },
  computed: {
    enableSms: {
      get: function() {
        return this.$store.getters.customer.sms_outbid == 'y'
      },
      set: function(value) {
        if(value) {
         // commenting out - seems like our addition of cards made this behave unexpectedly
          //this.$refs.phoneNumber.$refs.PhoneNumberInput.focusInput()
        }
        let notifications = {
          sms_number: '',
          sms_outbid: 'n'
        }
        if (value) {
          notifications.sms_outbid = 'y'
        }
        this.updateNotifications(notifications)
      } 
    },
    enableEmail: {
      get: function() {
        return this.$store.getters.customer.email_outbid == 'y'
      },
      set: function(value) {
        let notifications = {
          email_outbid: 'n'
        }
        if (value) {
          notifications.email_outbid = 'y'
        }
        this.updateNotifications(notifications)
      }
    },
    phoneNumber: {
      get: function() {
        return this.$store.getters.customer.sms_number
      },
      set: function(value) {
        this.$store.dispatch('updateCustomerSmsNumber', value)
      }
    },
    customerEmailAddress: function () {
      return this.$store.getters.customer.email
    }
  },
  mounted () {
    if(this.$store.getters.customer.sms_number != '') {
      this.enableSms = true
      this.isValidSmsNumber = true
      this.phoneNumber = this.$store.getters.customer.sms_number
    }
  },
  methods: {
    updateNotifications (payload) {
      var self = this
      let notifications = {
        sms_number: this.$store.getters.customer.sms_number,
        sms_outbid: (this.$store.getters.customer.sms_number == '' ? 'n' : 'y'),
        email_outbid: this.$store.getters.customer.email_outbid
      }
      if (typeof payload.sms_number != 'undefined') {
          notifications.sms_number = payload.sms_number
      }
      if (typeof payload.sms_outbid != 'undefined') {
          notifications.sms_outbid = payload.sms_outbid
      }
      if (typeof payload.email_outbid != 'undefined') {
          notifications.email_outbid = payload.email_outbid
      }
      this.$store.dispatch('updateCustomerNotifications', notifications)
    },
    smsNumberUpdate (payload) {
      //short -circuit if not valid number
      if(!payload.isValid) {
        this.isValidSmsNumber = false
          return false
      }

      this.isValidSmsNumber = true

      // update the store with the current sms info
      let notifications = {
        sms_number: '',
        sms_outbid: 'n'
      }

      notifications.sms_outbid = 'y';
      // nationalNumber is the number as an integer - we could use formatted number options if we'd like instead
      notifications.sms_number = payload.phoneNumber
      this.updateNotifications(notifications)
    },
    smsNumberBlur () {
      if(this.isValidSmsNumber) {
        return true
      }

      let notifications = {
        sms_number: '',
        sms_outbid: 'n'
      }

      this.updateNotifications(notifications)
    }
  }
}

</script>

<style scoped>

</style>
